var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonetizationOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM13.41 20V18.09C15.15 17.76 16.52 16.76 16.53 14.93C16.53 12.41 14.37 11.54 12.35 11.02C10.33 10.5 9.68 9.95 9.68 9.11C9.68 8.15 10.58 7.47 12.08 7.47C13.66 7.47 14.25 8.23 14.3 9.34H16.26C16.2 7.81 15.27 6.4 13.41 5.95V4H10.74V5.93C9.02 6.3 7.63 7.42 7.63 9.14C7.63 11.19 9.33 12.21 11.81 12.81C14.04 13.34 14.48 14.12 14.48 14.95C14.48 15.56 14.04 16.54 12.08 16.54C10.25 16.54 9.53 15.72 9.43 14.67H7.47C7.58 16.61 9.03 17.71 10.74 18.07V20H13.41Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationOn);
export default __webpack_public_path__ + "static/media/monetization-on.b64c00995197e86583715a7ccf9b7029.svg";
export { ForwardRef as ReactComponent };